import type { FC } from 'react';
import React from 'react';
import cx from 'classnames';
import { MDText } from 'i18n-react';

import { StarIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import { useListType, useSetListType } from 'Stores/ListStore/ListStore';
import { LIST_TYPES } from 'Utilities/consts';

import texts from '../../VehicleListV2.texts.json';

import styles from './FilterBarStart.module.scss';

const LocalT = new MDText(texts);

export const ShortlistChip: FC = () => {
	const listType = useListType();
	const setListType = useSetListType();
	const isActive = listType === LIST_TYPES.shortlist;

	return (
		<div className={cx({ [styles.shortlistActive]: isActive })}>
			<Chip
				reverse
				className={cx({ [styles.iconOutline]: !isActive })}
				data-testid="filter-chip-shortlist"
				icon={() => <StarIcon filled={isActive} />}
				label={LocalT.translate('filterBar.shortlist')}
				onClick={() => setListType(isActive ? LIST_TYPES.auction : LIST_TYPES.shortlist)}
				selected={isActive}
				size="medium"
			/>
		</div>
	);
};
